import { CardContent, Typography, Grid } from "@mui/material";
import ProjectExternalLinks from './ProjectLinksComponent';

const QuickLinks = ({ projectData, selectedProjectId }) => {
	return (
		<CardContent sx={{ padding: 0 }}>
			{projectData ? (
				<Grid container justifyContent="center" sx={{ marginLeft: '20px' }}>
					<Grid sx={{marginBottom: '20px'}}>
						<ProjectExternalLinks
							selectedProjectId={selectedProjectId}
							projectData={projectData}
						/>
					</Grid>
				</Grid>
			) : (
				<div style={{ textAlign: 'center' }}>
					<Typography variant="body1">--</Typography>
				</div>
			)}
		</CardContent>
	);
};

export default QuickLinks;
